import { render, staticRenderFns } from "./Expositors.vue?vue&type=template&id=4b77c93a"
import script from "./Expositors.vue?vue&type=script&lang=js"
export * from "./Expositors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports